<template>
  <div class="mk-organisationusers col-12 p-0">

    <div class="container-fluid px-0">
      <div class="row mx-0">

        <div class="col-12 px-0">
          <div class="user-card dashboard-card">

            <div
              class="
                mb-4
                px-0
                d-flex
                flex-column flex-md-row
                justify-content-start justify-content-md-between
                align-items-md-center align-items-start
              "
            >
                <div class="d-flex flex-column flex-md-row">
                    <h3 class="ml-0 mb-3">Users</h3>
                </div>

              <div class="d-flex flex-column flex-md-row">
                <button
                  @click="addNewItem"
                  class="btn btn-secondary mb-3 mb-md-0 ml-md-3"
                >
                  New User
                </button>
              </div>
            </div>


            <paginated-table :headers="headers" ref="paginationRef">
            </paginated-table>

            <v-dialog v-model="dialog" max-width="600px" scrollable overlay-opacity="0.8" overlay-color="#000">
              <v-card class="mk-note-modal hf-dialog">
                <v-card-title>
                  <div
                    class="
                      w-100
                      d-flex
                      justify-content-between
                      align-items-center
                    "
                  >
                    <h2 class="mb-0">{{ user.id ? "Edit" : "Create" }} User</h2>
                  </div>
                </v-card-title>

                <v-card-text class="py-0">
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <label>Name</label>
                        <v-text-field
                          outlined
                          v-model="user.name"
                          placeholder=""
                          class="text-field"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <label>Phone</label>
                        <v-text-field
                          outlined
                          v-model="user.phone"
                          placeholder=""
                          class="text-field"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <label>Email</label>
                        <v-text-field
                          outlined
                          v-model="user.email"
                          placeholder=""
                          class="text-field"
                          type="email"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row v-if="!this.user.id">
                      <v-col cols="12">
                        <label>Password</label>
                        <v-text-field
                          outlined
                          v-model="user.password"
                          placeholder=""
                          class="text-field"
                          type="password"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row v-if="!this.user.id">
                      <v-col cols="12">
                        <label>Re-enter Password</label>
                        <v-text-field
                          outlined
                          v-model="user.password_confirmation"
                          placeholder=""
                          class="text-field"
                          type="password"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <label>Status</label>
                        <v-select
                          outlined
                          :items="user_statuses"
                          item-value="id"
                          item-text="name"
                          v-model="user.active"
                          append-icon="fal fa-chevron-down"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <div
                          class="
                            d-flex
                            justify-content-between
                            align-items-center
                          "
                        >
                          <button
                            @click="dialog = false"
                            class="btn btn-default"
                            text
                          >
                            Cancel
                          </button>

                          <button
                            @click="saveItem"
                            color="primary"
                            text
                            class="btn btn-success"
                          >
                            Save
                          </button>
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </div>

        <div class="container-fluid mb-4 px-0">
            <div class="row mx-0">
                <div class="col-12 px-0">
                    <div class="user-card hf-base-card bg-white">

                        <v-dialog v-model="dialog" max-width="600px" scrollable overlay-opacity="0.8" overlay-color="#000">
                            <v-card class="mk-note-modal hf-dialog">
                                <v-card-title>
                                    <div class="w-100 d-flex justify-content-between align-items-center">
                                        <h2 class="mb-0">{{ user.id ? 'Edit' : 'Create' }} User</h2>
                                    </div>
                                </v-card-title>

                                <v-card-text class="py-0">
                                    <v-container>
                                        <v-row>
                                            <v-col cols="12">
                                                <label>Name</label>
                                                <v-text-field
                                                    outlined
                                                    v-model="user.name"
                                                    placeholder=""
                                                    class="text-field"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12">
                                                <label>Phone</label>
                                                <v-text-field
                                                    outlined
                                                    v-model="user.phone"
                                                    placeholder=""
                                                    class="text-field"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12">
                                                <label>Email</label>
                                                <v-text-field
                                                    outlined
                                                    v-model="user.email"
                                                    placeholder=""
                                                    class="text-field"
                                                    type="email"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="!this.user.id">
                                            <v-col cols="12">
                                                <label>Password</label>
                                                <v-text-field
                                                    outlined
                                                    v-model="user.password"
                                                    placeholder=""
                                                    class="text-field"
                                                    type="password"
                                                    required
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="!this.user.id">
                                            <v-col cols="12">
                                                <label>Re-enter Password</label>
                                                <v-text-field
                                                    outlined
                                                    v-model="user.password_confirmation"
                                                    placeholder=""
                                                    class="text-field"
                                                    type="password"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12">
                                                <label>Status</label>
                                                <v-select
                                                    outlined
                                                    :items="user_statuses"
                                                    item-value="id"
                                                    item-text="name"
                                                    v-model="userActive"
                                                    append-icon="fal fa-chevron-down"
                                                ></v-select>
                                            </v-col>
                                        </v-row>

                                    </v-container>
                                </v-card-text>

                                <v-card-actions>
                                    <v-container>
                                        <v-row>
                                            <v-col cols="12">
                                                <div
                                                    class="d-flex justify-content-between align-items-center"
                                                >
                                                    <button
                                                        @click="dialog = false"
                                                        class="btn btn-default"
                                                        text
                                                    >
                                                        Cancel
                                                    </button>

                                                    <button
                                                        @click="saveItem"
                                                        color="primary"
                                                        text
                                                        class="btn btn-success"
                                                    >
                                                        Save
                                                    </button>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>

                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import User from "../../models/User";

export default {
  props: {
    organisation: {
      type: Object,
    },
    user_statuses: {
      type: Array,
    },
  },
  data() {
    return {
      headers: [
        { text: "ID", value: "id" },
        { text: "Name", value: "name" },
        { text: "Phone", value: "phone" },
        { text: "Email", value: "email" },
        {
          text: "Status",
          value: "active",
          formatter: "options",
          options: this.user_statuses,
          sortable: false,
        },
        { text: "Actions", value: "actions", sortable: false },
      ],
      dialog: false,
      user: new User({}),
      userActive: 0
    };
  },
  methods: {
        async getModelDetails() {
            return User.where("organisation_id", this.organisation.id);
        },

        addNewItem() {
        this.user = new User({});
        this.dialog = true;
        },

        saveItem() {
            this.user.organisation_id = this.organisation.id;
            this.user.active = this.userActive;

            this.user.save()
                .then((response) => {
                    if(!response.data) {
                        this.dialog = false;
                        this.$refs.paginationRef.readDataFromAPI();
                    }
                });
        },

        editItem(data) {
            this.dialog = true;
            this.user = data;

            this.userActive = data.active ? 1 : 0;
        },

        deleteItem(data) {
            this.user = data;
            this.$swal({
                title: "Are you sure you want to delete this?",
                customClass: {
                    confirmButton: "order-2 btn btn-danger ml-1",
                    cancelButton: "order-1 btn hf-btn-secondary mr-1",
                },
                buttonsStyling: false,
                showCancelButton: true,
                confirmButtonText: "Confirm",
                iconHtml: "",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    let user = new User(this.user);
                    user.delete().then((response) => {
                        this.$refs.paginationRef.readDataFromAPI();

                        Vue.swal({
                            title: ' ',
                            text: 'Deleted',
                            icon: 'success',
                            toast: true,
                            position: 'top-end',
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    });
                }
            });
        }
    },
};
</script>
